"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unfoldFormatSigma = void 0;
const core_1 = require("../core");
function unfoldFormatSigma(core) {
    switch (core["@kind"]) {
        case "Sigma": {
            const carType = (0, core_1.formatCore)(core.carType);
            const { bindings, cdrType } = unfoldFormatSigma(core.cdrType);
            return { bindings: [carType, ...bindings], cdrType };
        }
        default: {
            return { bindings: [], cdrType: (0, core_1.formatCore)(core) };
        }
    }
}
exports.unfoldFormatSigma = unfoldFormatSigma;
//# sourceMappingURL=unfoldFormatSigma.js.map